import moment from "moment";

const MyDateFormat = "YYYY-MM-DD";
const DateTimeFormat = "YYYY-MM-DD HH:mm";
const DateTimeFormatWithZone = "YYYY-MM-DD HH:mm:ss.SSS Z";
export const currentDateString = () => moment().format(MyDateFormat);
export const formatMMMDateString = fromString => fromString === null ? "" : moment(fromString).format("MMM D, YYYY");
export const formatDateString = fromString => moment(fromString).format(MyDateFormat);
export const formatDateTimeString = fromString => moment(fromString).format(DateTimeFormat);
export const formatDateTimeStringWithZone = fromString => fromString === null ? "" : moment(fromString).format(DateTimeFormatWithZone);
export const formatMMddyyyyDateString = fromString => (fromString === null || fromString === undefined || fromString === "") ?
    "" : moment(fromString).format("MM/DD/YYYY");